module.exports = __webpack_public_path__ + "static/media/cl_4.d39fadd4.jpg";